export type FeedbackType = 'bug_report' | 'feature_request' | 'other';

export const feedbackTypeOptions = [
  { label: 'Bug Report', value: 'bug_report' },
  { label: 'Feature Request', value: 'feature_request' },
  { label: 'Other', value: 'other' },
];

export type SubmitFeedbackPayload = {
  application_id: string;
  type: FeedbackType;
  text: string;
  attachments?: File[];
};
